import { Global } from '@emotion/react';
import { SwipeableDrawer } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { MdOutlineSwipeLeft, MdOutlineSwipeRight } from 'react-icons/md';
import * as S from './styles';
import { useDrawer } from '../hooks';

const drawerBleeding = 40;

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface Props {
  position: Anchor;
  children: JSX.Element;
}

export function MaterialDrawer({ position, children }: Props) {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const { isOpen, setIsOpen } = useDrawer();

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  useEffect(() => {
    setState({ ...state, [position]: isOpen });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(state[position]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <>
      <Global
        styles={{
          '.MuiDrawer-root': { zIndex: '1!important' },
          '.PrivateSwipeArea-root': { zIndex: '1!important' },
          '.MuiDrawer-root > .MuiPaper-root': {
            width: `calc(100% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />

      <SwipeableDrawer
        anchor={position}
        open={state[position]}
        onClose={toggleDrawer(position, false)}
        onOpen={toggleDrawer(position, true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <S.DrawerContent>
          {createPortal(
            <S.SwipeButton
              $isOpen={state[position]}
              onClick={
                state[position]
                  ? toggleDrawer(position, false)
                  : toggleDrawer(position, true)
              }
            >
              <S.SwipeAnimation $isOpen={state[position]}>
                {state[position] ? (
                  <MdOutlineSwipeRight size={20} />
                ) : (
                  <MdOutlineSwipeLeft size={20} />
                )}
              </S.SwipeAnimation>
            </S.SwipeButton>,
            document.body
          )}

          {children}
        </S.DrawerContent>
      </SwipeableDrawer>
    </>
  );
}
